import { LeftOutlined } from "@ant-design/icons";
import { Link, Outlet } from "react-router-dom";

import { ROUTES } from "@/constants";

export const AuthLayout = () => (
  <main className="auth-shell">
    <div className="auth-shell__content">
      <Link className="auth-shell__back-home" to={ROUTES.HOME}>
        <LeftOutlined />
        <span>Về trang chủ</span>
      </Link>

      <Outlet />
    </div>
  </main>
);
